import React from 'react'
import styled from 'styled-components'

import { white, borderColor } from 'styles/colors'
import { header2 } from 'styles/texts'

import Spinner from 'components/Spinner'

const Wrapper = styled.div`
  border-radius: 4px;
  background-color: ${white};
  width: ${props => (props.small ? '470px' : '620px')};
  max-width: calc(100vw - 40px);
  position: relative;
`

const Title = styled.div`
  ${header2};
  border-bottom: 1px solid ${borderColor};
  text-align: center;
  padding: 20px 0;
`

const Overlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: white;
`

const FormContainer = props => (
  <Wrapper {...props}>
    <Title>{props.title || '\u00A0'}</Title>
    {props.children}
    {props.loading && (
      <Overlay>
        <Spinner />
      </Overlay>
    )}
  </Wrapper>
)

export default FormContainer



// WEBPACK FOOTER //
// ./src/components/form/FormContainer.js